import { montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid'
import { t } from 'i18next'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

export default function Faq({ faq }) {

  const [indexChoosed, setIndexChoosed] = useState(0)
  const { t } = useTranslation();

  const handleShowDetailFaq = (index) => {
    setIndexChoosed(prev => prev == index ? null : index)
  }

  return (
    <div className='flex lg:px-8 bg-gray-cool-50 py-16 w-full h-full px-4'>
      <div className='flex max-w-[1280px] lg:mx-auto lg:container w-full faq-display lg:flex-row flex-col'>
        <div className='faq-title flex w-full md:mx-auto lg:mx-0 md:justify-center md:items-center lg:justify-start lg:items-start'>
          <div className='faq-position relative md:left-10 lg:left-0 flex w-[60%] lg:w-[50%] flex-col'>
            <div className='w-9 text-blue-primary-500'>
              <QuestionMarkCircleIcon />
            </div>
            <div className={`flex whitespace-nowrap pt-6 pb-[12px] text-gray-cool-700 ${montserratSemibold.className} leading-[44px] text-[36px]`}>{t("bookeeping_more_question")}</div>
            <p className={`flex w-[20rem] text-gray-cool-500 ${montserratNormal.className}`}>{t("bookeeping_question_desc")}</p>
          </div>
        </div>
        <div className='grid py-16 faq-padding lg:pl-[80px] md:py-16 faq-padding grid-cols-1 w-full'>
          {
            faq.map((val, index) => (
              <div key={index} className={`flex flex-col w-full`}>
                <div onClick={() => handleShowDetailFaq(index)} className={`flex justify-between relative hover:cursor-pointer w-full`}>
                  {
                    t(val.title) != '' && (
                      <>
                        <p className={`${montserratMedium.className} text-gray-cool-700 md:max-w-[496px] lg:max-w-none text-[18px] w-[20rem] md:w-full`}>{t(val.title)}</p>
                        <div className={`relative right-0 w-4 lg:w-5`}>
                          {
                            index == indexChoosed ? (<><MinusIcon /></>) : (<><PlusIcon /></>)
                          }
                        </div>
                      </>
                    )
                  }

                </div>
                {
                  index == indexChoosed && (
                    <div dangerouslySetInnerHTML={{ __html: t(val.description) }} className={`flex text-gray-cool-500 pt-4 ${montserratNormal.className}`}>

                    </div>
                  )
                }
                {
                  index < faq.length - 1 && t(val.title) != '' && (
                    <div className='flex border-[1px] my-6 border-gray-cool-200' />
                  )
                }
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
